import React from "react";

// Components
import NumberFormat from "react-number-format";

const NumberFormatCustom = ({
  inputRef,
  onChange,
  fixedDecimalScale = true,
  isNumericString = true,
  decimalScale = 2,
  allowNegative = false,
  ...rest
}) => {
  return (
    <NumberFormat
      {...rest}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      isNumericString={isNumericString}
      fixedDecimalScale={fixedDecimalScale}
      decimalScale={decimalScale}
      allowNegative={allowNegative}
    />
  );
};

export default NumberFormatCustom;
